<app-page inTutorial="true">
  <update-profile
    [loggedInUser]="globalVars.loggedInUser"
    [inTutorial]="true"
  ></update-profile>
</app-page>
